/* nb-cmax-quiz: tap or keyboard-toggle rows (role=checkbox) to tick, reveal result after
   >=2 ticks. Scoped to each [data-nb-quiz] root. Not an nb-ui.js module: specific to this
   section. */
(function () {
  function initQuiz(root) {
    if (root.dataset.nbInitQuiz) return;
    root.dataset.nbInitQuiz = 'true';

    var rows = root.querySelectorAll('[data-nb-quiz-row]');
    var result = root.querySelector('[data-nb-quiz-result]');
    var resultText = root.querySelector('[data-nb-quiz-result-text]');
    var template = resultText ? resultText.textContent.trim() : '';

    function count() {
      var n = 0;
      rows.forEach(function (row) {
        if (row.getAttribute('aria-checked') === 'true') n += 1;
      });
      return n;
    }

    function update() {
      var n = count();
      if (resultText && template) {
        resultText.textContent = template.replace('{n}', n);
      }
      if (result) {
        if (n >= 2) {
          result.hidden = false;
          result.classList.remove('hidden');
          result.classList.add('flex');
        } else {
          result.hidden = true;
          result.classList.add('hidden');
          result.classList.remove('flex');
        }
      }
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        var checked = row.getAttribute('aria-checked') === 'true';
        row.setAttribute('aria-checked', checked ? 'false' : 'true');
        update();
      });
    });

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-nb-quiz]').forEach(initQuiz);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
